var _circle, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 61,
    viewBox: "0 0 85 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 30.5,
    r: 30,
    fill: "#F7F1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 31.1493H54.5V29.8506H34.5V31.1493ZM43.7593 20.5V40.5H45.2407V20.5H43.7593Z",
    fill: "#E0CCB8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 22.5,
    width: 13,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 32.5,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 32.5,
    width: 9,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 33.5,
    width: 13,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 33.5,
    width: 6,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 22.5,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#EEE7DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmpty);
export default __webpack_public_path__ + "static/media/add-empty.57d41b31954fe5230c5bf83c7d34860e.svg";
export { ForwardRef as ReactComponent };